module.exports = __webpack_public_path__ + "static/media/babtl-logo.8f6d0e44.jpg";